export const SettingsTab = () => (
  <>
    <p>design</p>
  </>
)
